import { FC, useEffect, useMemo, useState } from "react";
import { BreadCrumbs } from '../../../components/BreadCrumbs/breadCrumbrs'
import { i18n } from "../../../translate/i18n";
import { ModalDelete } from '../../../components/Modals/General/ModalDelete/ModalDelete'
import { useAggregatorCategory } from "./factory/useAggregadorCategory";
import { ModularDataTable } from '../../../components/ModularDataTable'
import { createColumns } from "./factory/generateColumns";
import { createActions } from "./factory/actionsFactory";
import { useNavigate } from "react-router-dom";
import { Button } from '../../../components/Button/Button'
import useModals from "../../../hooks/useModals";

export const AggregadorCategory: FC = () => {
    const {
        aggregatorCategories,
        tableLoading,
        setTableLoading,
        pagination,
        sorting,
        handleDataChange,
        handlePaginationChange,
        handleSortingChange,
        getAggregatorClassification,
        deleteAggregatorClassification,
    } = useAggregatorCategory()
    const navigate = useNavigate()
    const { showDeleteModal } = useModals()
    const [deleteId, setDeleteId] = useState<number>(0)

    const columns = useMemo(() => createColumns({ switchStatus: getAggregatorClassification }), [])

    const actions = useMemo(() => createActions({
        navigate,
        showDeleteModal,
        setDeleteId,
    }), [])

    async function loadPage() {
        setTableLoading(true)
        await getAggregatorClassification()
        setTableLoading(false)
    }

    useEffect(() => {
        loadPage()
    }, [])


    return (
        <div className='row g-5 gx-xxl-12'>
            <div className='card card-xxl-stretch mb-5 mb-xl-12'>
                <div className='card-header py-5'>
                    <h3 className='card-title align-items-start flex-column'>
                        <span className='card-label fw-bolder fs-3 mb-1'>{i18n.t(`aggregador_classification.title`)}</span>
                        <BreadCrumbs />
                        <span className='text-muted mt-1 fw-bold fs-7'>
                            {i18n.t(
                                `aggregador_classification.subTitle`
                            )}
                        </span>
                    </h3>

                    <div className='card-toolbar'>
                        <Button
                            text='Adicionar Categoria'
                            color='primary'
                            iconColor='#FFF'
                            icon='fas fa-plus'
                            size='small'
                            horizontalPadding={6}
                            btnAttr={{
                                type: 'button',
                            }}
                            click={() => navigate('/agregador/category/create')}
                            btnClass='mb-5 fw-bolder'
                        />
                    </div>
                </div>

                <div className='card-body'>
                    <ModularDataTable
                        data={aggregatorCategories}
                        columns={columns}
                        actions={actions}
                        pagination={pagination}
                        onPaginationChange={handlePaginationChange}
                        sorting={sorting}
                        onSortingChange={handleSortingChange}
                        onDataChange={handleDataChange}
                        searchable={true}
                        searchPlaceholder='Pesquisar categoria...'
                        loading={tableLoading}
                        selectable={false}
                        striped={false}
                        hover={false}
                        size='md'
                        className='table-row-bordered table-row-gray-200'
                        alterColumns
                        persistPageKey='category_aggregator'
                        persistContextKey='default'
                    />
                </div>
            </div>

            <ModalDelete confirmAction={() => deleteAggregatorClassification(deleteId)} text='delete_product_observation' />
        </div>
    )
}